const columns = [
  {
    title: "内容分区",
    links: [
      { label: "本周新番", href: "#weekly" },
      { label: "最新话更新", href: "#latest" },
      { label: "热门连载", href: "#ongoing" },
      { label: "分类检索", href: "#catalog" },
    ],
  },
  {
    title: "追番常用",
    links: [
      { label: "追番人气榜", href: "#ranking" },
      { label: "常见问题", href: "#faq" },
      { label: "关于本站", href: "#about" },
      { label: "更新时段说明", href: "#about" },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="bg-secondary-900 text-secondary-50">
      <div className="mx-auto max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-flower-fill text-lg"></i>
              </span>
              <span className="font-heading text-xl">樱花动漫在线</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-secondary-100/85">
              本站聚合整理新番、更新、追番、连载、本周新番与最新话等公开信息，帮助观众更快了解当季动画的播出节奏与追更方向。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              <span className="rounded-full bg-secondary-800 px-3 py-1 text-xs text-secondary-100">每日 18:00 起更新</span>
              <span className="rounded-full bg-secondary-800 px-3 py-1 text-xs text-secondary-100">当季新番排期</span>
              <span className="rounded-full bg-secondary-800 px-3 py-1 text-xs text-secondary-100">分类本地筛选</span>
            </div>
          </div>

          {columns.map((col) => (
            <div key={col.title}>
              <h3 className="font-heading text-base text-secondary-50">{col.title}</h3>
              <ul className="mt-4 space-y-2.5">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm text-secondary-100/85 transition-colors hover:text-background-50"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-secondary-800 pt-6 text-xs text-secondary-100/70 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 樱花动漫在线 · 本站为动漫信息聚合展示站点，内容以公开播出信息整理为主。</p>
          <p>站内条目、评分与追番人数均为展示数据，实际以官方播出为准。</p>
        </div>
      </div>
    </footer>
  );
}